"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("App error:", error);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-lg font-semibold text-slate-900">Une erreur est survenue</h2>
      <p className="max-w-md text-center text-sm text-slate-600">
        {error.message || "Erreur inattendue. Réessayez ou rechargez la page."}
      </p>
      <button
        type="button"
        onClick={() => reset()}
        className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
      >
        Réessayer
      </button>
    </div>
  );
}
